import React from 'react';
import '../styles/FunctionIcon.css';

const FunctionIcon = ({ name, Icon, selected }) => {
  return (
    <div className={` functionicon ${selected && 'selected'} `}>
      <Icon />
      <h4>{name}</h4>
    </div>
  );
};

export default FunctionIcon;
